import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// project-imports
import router from 'routes';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5 * 60 * 1000, retry: 1 } }
});
import ThemeCustomization from 'themes';
import { ThemeScopeProvider } from 'contexts/ThemeScopeContext';

import AppErrorBoundary from 'components/AppErrorBoundary';
import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import Metrics from 'metrics';

// auth-provider
import { AuthProvider } from 'features/auth/context/AuthContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeScopeProvider>
        <ThemeCustomization>
          <AppErrorBoundary>
            <RTLLayout>
              <Locales>
                <ScrollTop>
                  <AuthProvider>
                    <>
                      <Notistack>
                        <RouterProvider router={router} />
                        <Snackbar />
                      </Notistack>
                    </>
                  </AuthProvider>
                </ScrollTop>
              </Locales>
            </RTLLayout>
          </AppErrorBoundary>
        </ThemeCustomization>
      </ThemeScopeProvider>
      <Metrics />
    </QueryClientProvider>
  );
}
